import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT, waLink } from "@/data/site";

export const CallButton = ({ label = `Call ${CONTACT.phoneDisplay}`, testid = "cta-call", className = "" }) => (
  <a
    href={CONTACT.phoneTel}
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-stone-950 shadow-lg shadow-gold/20 transition-all duration-300 hover:bg-gold-bright hover:shadow-gold/40 active:scale-[0.98] ${className}`}
  >
    <Phone size={15} className="transition-transform duration-300 group-hover:-rotate-12" />
    {label}
  </a>
);

export const WhatsAppButton = ({ label = "WhatsApp Booking", testid = "cta-whatsapp", service, className = "" }) => (
  <a
    href={waLink(service)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-600/25 transition-all duration-300 hover:bg-[#1fb857] active:scale-[0.98] ${className}`}
  >
    <WhatsAppIcon size={16} />
    {label}
  </a>
);
